// =============================================================================
// gst.ts — T-403. ONE place for the 1/11th GST split. The platform review
// found five hand-rolled copies of `inc / 1.1` with subtly different rounding
// order (the DB derives gst FROM ex — mig 167 — so cent-level drift was
// possible on odd totals). Everything ex/gst-from-inc goes through here.
// =============================================================================

export const GST_RATE = 0.10;

/** Split a GST-inclusive amount into { ex, gst } — matching the DB's rounding
 *  (ex first, gst = inc − ex) so app and Postgres never disagree by a cent. */
export function splitFromInc(inc: number, gstFree = false): { ex: number; gst: number } {
  const n = Number(inc) || 0;
  if (gstFree) return { ex: round2(n), gst: 0 };
  const ex = round2(n / (1 + GST_RATE));
  return { ex, gst: round2(n - ex) };
}

/** GST on an ex-GST amount (the DB's app.* convention: round(ex * 0.10, 2)). */
export function gstFromEx(ex: number, gstFree = false): number {
  if (gstFree) return 0;
  return round2((Number(ex) || 0) * GST_RATE);
}

export function incFromEx(ex: number, gstFree = false): number {
  return round2((Number(ex) || 0) + gstFromEx(ex, gstFree));
}

const round2 = (v: number) => Math.round(v * 100) / 100;
